/**
 * Created by Ivan on 20.06.2026
 */

const LorysDerbyExtraBarIcon = {
    customIcon: function () {
        return Prefab.instantiate(bundles.questsgroupicon.jsons.lorysderby_extrabar_icon_prefab_json);
    },
    extraBarWeight: 100002
};
